var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProveedores(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Proveedores"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Proveedores",
    clipPath: "url(#clip-Proveedores)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2106",
    "data-name": "Grupo 2106",
    transform: "translate(-11.821 -11.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_813",
    "data-name": "Trazado 813",
    d: "M0,0H124.988V124.988H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2105",
    "data-name": "Grupo 2105",
    transform: "translate(0.338 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_808",
    "data-name": "Trazado 808",
    d: "M10.277,8H84.769a8.275,8.275,0,0,1,8.277,8.277V65.939a8.275,8.275,0,0,1-8.277,8.277H10.277A8.275,8.275,0,0,1,2,65.939V16.277A8.275,8.275,0,0,1,10.277,8Z",
    transform: "translate(2.138 8.554)",
    fill: "none",
    stroke: "#6c637b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_809",
    "data-name": "Trazado 809",
    d: "M2,20H93.046",
    transform: "translate(2.138 21.385)",
    fill: "none",
    stroke: "#6c637b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_810",
    "data-name": "Trazado 810",
    d: "M0,0H99.323V99.323H0Z",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProveedores);
export default __webpack_public_path__ + "static/media/proveedores.e79d270e86f3ac8c3391557f53f4b5a7.svg";
export { ForwardRef as ReactComponent };